import AdminReducer from './reducers/Admin.reducer';
import AuthorizedUser from './reducers/Auth.reducer';
import ConfigReducer from './reducers/Config.reducer';
import EmployeeReducer from './reducers/Employee.reducer';
import FeatureReducer from './reducers/Feature.reducer';
import ModalReducer from './reducers/Modal.reducer';
import ReportReducer from './reducers/Report.reducer';
import RoundReducer from './reducers/Round.reducer';
import StoplightReducer from './reducers/Stoplight.reducer';
import TaskReducer from './reducers/Task.reducer';
import TemplateReducer from './reducers/Template.reducer';
import ToastReducer from './reducers/Toast.reducer';
import UserReducer from './reducers/User.reducer';

const rootReducers = {
  AuthorizedUser,
  AdminReducer,
  ConfigReducer,
  EmployeeReducer,
  FeatureReducer,
  ModalReducer,
  ReportReducer,
  RoundReducer,
  StoplightReducer,
  TaskReducer,
  TemplateReducer,
  ToastReducer,
  UserReducer
};

export default rootReducers;
